import { getSerializer } from '@shared/serializers/serializer';

export const pictures = {
  type: 'picture',
  attributes: ['ownertType', 'ownerId', 'url', 'type', 'filename', 'isDeleted', 'createdAt', 'updatedAt']
};

export const PicturesSerializer = getSerializer(pictures);
